/** Backend limit of one chat answer (#13383 contract); the description comes from the line (60 chars) and is never typed here. */
export const HTS_ASSISTANT_ANSWER_MAX_LENGTH: number = 4000;
/** Debounce of the similar-products search under the item description (same pace as the catalog fast search). */
export const HTS_SUGGESTIONS_DEBOUNCE_MS: number = 800;
/** The company-wide suggestions search answers `[]` to shorter texts (#13534): no request below this. */
export const HTS_SUGGESTIONS_MIN_LENGTH: number = 3;
/** How long the "only English is supported" hint stays under the composer after a blocked character. */
export const HTS_ASSISTANT_ENGLISH_HINT_MS: number = 3000;
/** Lengths of the dotted groups of a full HTS number — the app's `0000.00.0000` mask (`8544.42.2000`). */
export const HTS_ASSISTANT_CODE_GROUP_LENGTHS: number[] = [4, 2, 4];
/** Ids of the conversations this client started from the line's stored description (their messages[0] is not shown). */
export const HTS_CHAT_AUTO_STARTED_STORAGE_KEY: string = 'hts-chat-auto-started';

/**
 * The as-window z-index for a drawer with the line panel: the panel hangs LEFT of the drawer and must cover the app menu
 * (`.sidebar`, z-index 1031) on narrow desktops. A z-index on the panel itself cannot leave the window's stacking context.
 */
export const HTS_LINE_PANEL_Z_INDEX: string = '1032';
